import Routes from "./routes";
import "./styles/style.scss";

const App = () => {
  return <Routes />;
};

export default App;
